export default __webpack_public_path__ + "static/media/football.b95e69d8.png";